module.exports = {
	name: 'id',
	validation(yup) {
		return yup.string().max(36);
	}
};
